import { IPermission } from '../interfaces/IPermission';
import { PermissionType } from '../enums/PermissionType';
import { i18n } from '../plugins/i18n';
import { IPermissionGroup } from '../interfaces/IPermissionGroup';

const PermissionData: Map<PermissionType, IPermission> = new Map<
  PermissionType,
  IPermission
>();
const PermissionGroups: IPermissionGroup[] = [];

for (let item in PermissionType) {
  if (isNaN(Number(item))) {
    const key = item
      .split(/(?=[A-Z])/)
      .join('.')
      .toLowerCase();

    const perm: any = {
      id: PermissionType[item],
      key,
      title: 'permissions.' + key,
    };

    // @ts-ignore
    PermissionData.set(PermissionType[item], perm);

    const groupKey = key.split('.')[0];
    let group = PermissionGroups.find((value) => value.key === groupKey);
    if (!group) {
      PermissionGroups.push(
        (group = {
          key: groupKey,
          title: groupKey,
          items: [],
        })
      );
    }
    group.items.push(perm);
  }
}

export { PermissionData, PermissionGroups };
